import { tableColumns } from '../SharedProductList';

const columns = [
  tableColumns.name,
  tableColumns.price,
  tableColumns.supplyPrice,
  tableColumns.inventory,
  tableColumns.lowInventory,
  tableColumns.sku,
  tableColumns.tax,
  tableColumns.category,
  tableColumns.brand,
];

export default columns;
